'use client'

import React, { ReactElement, ReactNode, useState } from 'react'
import { ModalNew } from '../common/ModalNew'

export function ProgramInfoBoxModal(props: {
  children: ReactNode
  modalTitle: string
  modalContent: string
}): ReactElement | null {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  function closeModal() {
    setIsOpen(false)
  }

  return (
    <>
      <div onClick={() => setIsOpen(true)} className="cursor-help">
        {props.children}
      </div>
      {isOpen && (
        <ModalNew close={closeModal} isOpen={isOpen} title={props.modalTitle}>
          <div className="p-5">
            <div
              className="prose mt-0 text-sm text-stone-800"
              dangerouslySetInnerHTML={{ __html: props.modalContent }}
            />
          </div>
        </ModalNew>
      )}
    </>
  )
}
